import { call, takeLatest } from 'redux-saga/effects';

import { LOGGED_IN, LOGGED_OUT, authChannelModel } from '@entities/auth-channel';
import { getUser } from '@entities/auth-user';
import { authBreadcrumb, captureAuthError, setAuthUserContext } from '@features/sentry-connect';
import { FirebaseUser } from '@shared/types';
import { Saga } from '@shared/types';

import { beforeAuth } from './before-auth';

export function* onAuth(handleSignedIn: Saga, handleSignedOut: Saga) {
  authBreadcrumb('onAuth: started');
  const currentUser: FirebaseUser | null = yield getUser();
  setAuthUserContext({ uid: currentUser?.uid ?? null, email: currentUser?.email ?? null });
  authBreadcrumb('onAuth: initial user resolved', {
    hasUser: Boolean(currentUser),
    uid: currentUser?.uid ?? null,
  });

  yield call(authChannelModel.handleUserAuthState, currentUser);

  yield takeLatest(authChannelModel.chan, function* ({ actions, type }) {
    authBreadcrumb('authChannel: received state', { type, redirectTo: actions?.redirectTo ?? null });
    yield call(beforeAuth, actions);

    try {
      switch (type) {
        case LOGGED_IN:
          yield call(handleSignedIn);
          break;
        case LOGGED_OUT:
          yield call(handleSignedOut);
          break;
        default:
          throw new Error('Unexpected value in authChan');
      }
    } catch (error: unknown) {
      captureAuthError(error, `authChannel:${type}`, {
        type,
        redirectTo: actions?.redirectTo ?? null,
      });
      throw error;
    }
  });
}
